import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Button from '../../../components/Button.js';
import WriteReview from '../../../components/dialogues/WriteReview';
import { useHistory } from 'react-router-dom';
import * as gtm from '../../../lib/gtm';
import * as track from '../../../lib/track';

const useStyles = makeStyles({
  root: {
    width: '100%',
    display: 'flex',
    flexWrap: 'nowrap',
    justifyContent: 'flex-start',
    padding: '1rem 0',
  },
});

const ActionButtons = ({providerUuid, itemType, data}) => {
  const classes = useStyles();
  const history = useHistory();
  const [writeReviewOpen, setWriteReviewOpen] = React.useState(false);
  const closeWriteReview = () => setWriteReviewOpen(false);
  const itemName = itemType === 'provider' ? data.name : data.title;
  const eventArgs = (itemType === 'provider') ? null : {listing_uuid: data.uuid};

  const clickWriteReview = () => {
    track.sendEvent(`write ${itemType} review button`, 'click', eventArgs, [providerUuid]);
    setWriteReviewOpen(true);
  };

  const clickRequestService = () => {
    track.sendEvent(`request ${itemType} service button`, 'click', eventArgs, [providerUuid]);
    gtm.sendEvent('click', {buttonName: 'Request Service'});
    history.push(`/requestservice/${itemType}/${data.slug}`);
  };

  return (
    <div className={classes.root}>
      <Button
        variant="outlined"
        label="Write a review"
        cssStyle="regular"
        aria-label="Write a review button"
        onClick={clickWriteReview}
      />
      <WriteReview
        open={writeReviewOpen}
        onClose={closeWriteReview}
        providerUuid={providerUuid}
        itemType={itemType}
        itemUuid={data.uuid}
        itemName={itemName}
      />
      {data.accredited && (
        <React.Fragment>
          <Button
            label="Request service"
            cssStyle="regular"
            aria-label="Request service button"
            onClick={clickRequestService}
          />
        </React.Fragment>
      )}
    </div>
  );
};

ActionButtons.propTypes = {
  providerUuid: PropTypes.string.isRequired,
  itemType: PropTypes.string.isRequired,
  data: PropTypes.object.isRequired,
};

export default ActionButtons;
